
import React from 'react';

interface FormButtonProps {
  result: 'W' | 'L' | 'D';
  onClick: () => void;
}

const getResultColor = (result: string) => {
  switch (result) {
    case 'W':
      return 'bg-green-500 text-white hover:bg-green-600';
    case 'L':
      return 'bg-red-500 text-white hover:bg-red-600';
    case 'D':
      return 'bg-gray-400 text-white hover:bg-gray-500';
    default:
      return 'bg-gray-200';
  }
};

export const FormButton: React.FC<FormButtonProps> = ({ result, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`w-5 h-5 flex items-center justify-center text-xs font-bold rounded cursor-pointer ${getResultColor(result)}`}
    >
      {result}
    </button>
  );
};
